module.exports = __webpack_public_path__ + "6f0a475a50c23c9a8156e66281813053.pdf";